module.exports = __webpack_public_path__ + "static/img/fig_cls.2d859cb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fig_cls.png
// module id = JF8R
// module chunks = 0